import { render, staticRenderFns } from "./ReadWord.vue?vue&type=template&id=1e96f49a&scoped=true"
import script from "./ReadWord.vue?vue&type=script&lang=js"
export * from "./ReadWord.vue?vue&type=script&lang=js"
import style0 from "./ReadWord.vue?vue&type=style&index=0&id=1e96f49a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96f49a",
  null
  
)

export default component.exports